import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { fittingLab } = Dictionary

const FittingLab = {
    inProcessList: async () => {
        return axios.get(BASE_URL + fittingLab.fittingLab())
    },
    orderReadyList: async (param:{}) => {
        return axios.put(BASE_URL + fittingLab.orderReady(), param)
    },
    updateOrderStatus: async (id:string,payload:{}) => {
        return axios.put(BASE_URL + fittingLab.updateOrderStatus(id), payload)
    },
    generatePdf: async (orderId: string) => {
        return axios.get(BASE_URL + fittingLab.generatePdf(orderId))
    },
    generateOrderForm: async (orderId: string) => {
        return axios.get(BASE_URL + fittingLab.orderForm(orderId))
    },

    // sales cart
    viewOrderDetails: async (id: string) => {
        return axios.get(BASE_URL + fittingLab.viewOrderDetails(id))
    },


}
export default FittingLab

